// Formatting helpers — consistent currency/number/percent display across all calculators.

export const CAD = (value, opts = {}) => {
  const { decimals = 0 } = opts;
  if (value === null || value === undefined || Number.isNaN(value)) return "$0";
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const CAD2 = (value) => CAD(value, { decimals: 2 });

export const num = (value, decimals = 0) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "0";
  return new Intl.NumberFormat("en-CA", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const pct = (value, decimals = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "0%";
  return `${(value * 100).toFixed(decimals)}%`;
};

export const pctPlain = (value, decimals = 2) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "0%";
  return `${Number(value).toFixed(decimals)}%`;
};

// Format a value according to a declared type used in calculator result fields.
export const formatByType = (value, type) => {
  switch (type) {
    case "currency":
      return CAD(value);
    case "currency2":
      return CAD2(value);
    case "percent":
      return pctPlain(value);
    case "number":
      return num(value);
    case "years":
      return `${num(value, value % 1 === 0 ? 0 : 1)} yr`;
    case "months":
      return `${num(value)} mo`;
    default:
      return String(value);
  }
};

export const clampNumber = (v, min, max) => {
  let n = Number(v);
  if (Number.isNaN(n)) n = 0;
  if (min !== undefined && n < min) n = min;
  if (max !== undefined && n > max) n = max;
  return n;
};
